import React, { useState, useEffect } from 'react'
import Departure from '../components/Departure.irtis'
import Header from '../components/HeaderSplit'
import Interruption from '../components/Interruption'
import Loader from '../components/Loader'
import PropTypes from 'prop-types'
import queryString from 'query-string'
import styled from 'styled-components'
import { palette } from '../styles/branding'
import { primaryTextColor, changeColorMode } from '../helpers/helpers'
import { useParams } from 'react-router-dom'
import { useMultivertrekken } from '../hooks/useMultivertrekken.hooks'

import {
  errorMessages,
  NO_DEPARTURES,
  noRealtimecopyA,
  noRealtimecopyB,
  noRealtimeInterval,
} from '../constants'

import {
  DepartureContainer,
  LineContainer,
  NoPassages,
  Passage,
  Passages,
  Vignette,
} from './PassagesSplit.styles'
import { renderTransportUtils } from './PassagesUtils'
import { noop } from 'swr/_internal'

const Container = styled.div`
  border-top: 5px solid
    ${(props) => (props.light ? palette.neutral2 : palette.dark3)};
  display: flex;
  flex-direction: column;
  flex: 1;
  &:first-child {
    border-top: none;
    .header-departure {
      visibility: visible;
    }
  }
`

const SplitPassages = ({ stop = {}, limit = 1 }) => {
  const [noRealTimeText, setNoRealTimeText] = useState(noRealtimecopyA)
  const { haltenummers } = useParams()
  const queryParam = queryString.parse(window.location.search)
  const isPreSubway = queryParam.premetro === 'true'
  const lightMode = changeColorMode(queryParam.inverse)
  const { passages, error, isLoading } = useMultivertrekken({
    stopIds: stop.id,
  })

  useEffect(() => {
    if (noRealtimecopyB) {
      const timeout = setTimeout(() => {
        setNoRealTimeText(
          noRealTimeText === noRealtimecopyA
            ? noRealtimecopyB
            : noRealtimecopyA,
        )
      }, noRealtimeInterval)
      return () => clearTimeout(timeout)
    }
    return noop
  }, [noRealTimeText])

  if (isLoading) {
    return <Loader />
  }

  const lines = passages.lijnen.slice(0, limit)

  return (
    <Container light={lightMode}>
      <Header
        stopName={stop.shortDescription}
        hasLines={lines.length > 0}
        currentTime={passages.serverTijd}
        showTime={haltenummers.split('+')[0] === stop.id}
      />
      {!!error && (
        <Interruption
          text={errorMessages.GET_PASSAGES_FAILURE}
          variant="error"
          color={primaryTextColor(queryParam)}
        />
      )}
      {!lines.length ? (
        <NoPassages light={lightMode}>{NO_DEPARTURES}</NoPassages>
      ) : (
        <Passages>
          {lines.map((line) => {
            return (
              <Passage
                key={`${line.vertrekTheoretischeTijdstip}-${line.lijnNummerPubliek}-${stop.id}`}
                light={lightMode}
                limit={limit}
              >
                <img
                  data-testid={renderTransportUtils(line.transportType).testId}
                  src={renderTransportUtils(line.transportType).icon}
                  alt={renderTransportUtils(line.transportType).alt}
                />
                <Vignette
                  backgroundColor={line.kleurAchterGrond}
                  backgroundBorder={line.kleurAchterGrondRand}
                  color={line.kleurVoorGrond}
                >
                  <span>{line.lijnNummerPubliek}</span>
                </Vignette>
                <LineContainer light={lightMode}>
                  <p>{line.lijnRichting}</p>
                  <p>Naar {line.bestemming}</p>
                </LineContainer>
                <DepartureContainer>
                  <Departure
                    line={line}
                    error={!!error}
                    currentTime={passages.serverTijd}
                    queryParam={queryParam}
                    lightMode={lightMode}
                    noRealtimeCopy={noRealTimeText}
                    isPreSubway={isPreSubway}
                  />
                </DepartureContainer>
              </Passage>
            )
          })}
        </Passages>
      )}
    </Container>
  )
}

SplitPassages.propTypes = {
  limit: PropTypes.number,
  stop: PropTypes.object,
}

export default SplitPassages
